import { GeneralPropsType } from "@/common/types";
import { useEffect, useState } from "react";
interface DelayMountedPropsType extends GeneralPropsType {
  delay?: number;
}
function DelayMounted({
  children,
  delay = 1000
}: DelayMountedPropsType) {
  const [allowMount, setAllowMount] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setAllowMount(true);
    }, delay);
  }, []);
  return <>{allowMount && children}</>;
}
export default DelayMounted;